import { render } from "./NotFound-404.vue?vue&type=template&id=151d1ec4&scoped=true&lang=html"
import script from "./NotFound-404.vue?vue&type=script&lang=js"
export * from "./NotFound-404.vue?vue&type=script&lang=js"

import "./NotFound-404.vue?vue&type=style&index=0&id=151d1ec4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151d1ec4"]])

export default __exports__